export enum CoverCode {
    STOLEN = "3",
    DAMAGE = "1",
    OXIDATION = "50",
    DELIVERY = "240",
    LOST = "75",
    BROKEN = "2",
    PAYMENT_METHOD = "1029",
    OTHER = "99"
}